import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { OperationsService } from 'src/app/core/services/operations.service';
import { Controparte } from '../../models/controparte';
import { SezioneContropartiResponse } from '../../models/dto/sezione-controparti-response';

@Component({
  selector: 'div [controparti-precedenti-add-form]',
  templateUrl: './controparti-precedenti-add.component.html',
  styleUrls: ['./controparti-precedenti-add.component.css']
})
export class ContropartiPrecedentiAddComponent implements OnInit {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
  contropartiPrecedenti: Controparte[] = [];
  contropartiSelezionate: Controparte[] = [];

  @Output() init: EventEmitter<any> = new EventEmitter<any>();

  idPratica: string;
  addControparteUrl: string;
  idSezione: string;
  idFascicolo: string;
  idParent: string;
  tipoFascicolo:string;
  selezionaTutti: boolean = false;

  constructor(private operations: OperationsService) { }


  ngOnInit() {
    if(this.idPratica){
      this.getContropartiPrecedenti();
    }
  }

  inserisciFirstControparte() { // inserisco solo la prima controparte, aspetto la risposta, aggiorno l'id sezione e inserisco le successive
    const controparteFirst = this.contropartiSelezionate[0];
    delete controparteFirst['id'];
    delete controparteFirst['selected'];
    this.operations.addParteOrLegaleInSezOrdinario(controparteFirst, this.addControparteUrl, this.idSezione, this.idFascicolo).subscribe(
      response => {
        this.idSezione = response.sezione.id; // aggiorno l'id sezione
        this.addedControparti(<SezioneContropartiResponse>response);
        this.inserisci();
      }
    );
  }

  inserisci() {
    this.contropartiSelezionate.forEach((controparte, i) => {
      if (i !== 0) { // la prima controparte è già stata inserita
        delete controparte['id'];
        delete controparte['selected'];
        controparte.legaleControparte = null;
        this.getRequest(controparte);
      }
    });
    this.createForm();
  }

  createForm(){
    this.contropartiSelezionate = [];
    this.contropartiPrecedenti.forEach(controparte=>{
      controparte.selected = false;
    });
    this.selezionaTutti=false;
  }

  getContropartiPrecedenti(){
    this.operations.getContropartiPrecedentiByPratica(this.idParent).subscribe(res=>{
      this.contropartiPrecedenti = <Controparte[]>res;
      this.init.emit(<Controparte[]>res);
    })

  }

  inizializza(idPratica, url, idSezione, idFascicolo, idParent, tipoFascicolo){
    this.idPratica=idPratica;
    this.addControparteUrl=url;
    this.idSezione=idSezione;
    this.idFascicolo=idFascicolo;
    this.idParent=idParent;
    this.tipoFascicolo = tipoFascicolo;
    this.selezionaTutti=false;
    this.contropartiSelezionate = [];
    this.getContropartiPrecedenti();
  }

  addControparteToList(controparte, event, index){
    controparte.selected = event;
    if(controparte.selected){
      this.contropartiSelezionate.push(controparte);
      if(this.contropartiPrecedenti.length===this.contropartiSelezionate.length) this.selezionaTutti=true;
    }
    else{
      this.contropartiSelezionate.splice(index,1);
      this.selezionaTutti =false;
    }
    console.log(this.contropartiSelezionate);
  }

  selectAllControparti(event){
    this.selezionaTutti=event;
    if(event){
      for(let i = 0; i<this.contropartiPrecedenti.length; i++){
        let controparte = this.contropartiPrecedenti[i];
        if(!this.contropartiSelezionate.find(el=>el===controparte)) this.addControparteToList(controparte, event, i);
      }
    }
    else{
      this.contropartiSelezionate=[];
      this.contropartiPrecedenti.forEach(controparte=>controparte.selected=event);
    }
  }


  getRequest(request: Controparte) {
    this.operations.addParteOrLegaleInSezOrdinario(request, this.addControparteUrl, this.idSezione, this.idFascicolo).subscribe(
      response => this.addedControparti(<SezioneContropartiResponse> response));
  }


  addedControparti(response: SezioneContropartiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }



}
